import { GetProfileDetailsDto } from './getprofiledetailsdto';

export interface GetProfileDto
{
    getClientTxnId(): string;
    getIdentifier(): string;
    getLanguage(): string;
    getMsisdn(): string;

    getGetProfileDetailsDto(): GetProfileDetailsDto;
}

export class GetProfileDtoImpl implements GetProfileDto
{
    private clientTxnId: string;
    private identifier: string;
    private language: string;
    private msisdn: string;
    private getProfileDetailsDto: GetProfileDetailsDto;

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTxnId;
    } 

    setIdentifier(identifier: string)
    {
        this.identifier = identifier;
    }
    getIdentifier(): string 
    {
        return this.identifier;
    } 

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    } 

    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    } 

    setProfileDetailsDto(getProfileDetailsDto: GetProfileDetailsDto)
    {
        this.getProfileDetailsDto = getProfileDetailsDto;
    }
    getGetProfileDetailsDto(): GetProfileDetailsDto 
    {
        return this.getProfileDetailsDto;
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getprofile/getprofiledto.ts